import { type BaseTicketComment } from "@mg/schemas/src/christo/catalyst";
import { Prohibit, Warning } from "@phosphor-icons/react";
import cx from "classnames";

import { useAppSelector } from "../../../utils/hooks";

export function CommentPin({
  comment,
  duration,
  onClick,
  trackWidth,
  jitter = 0,
}: {
  comment: BaseTicketComment;
  duration: number;
  onClick: (videoStart: number) => void;
  trackWidth?: number;
  jitter?: number;
}) {
  const left = ((comment?.videoStart ?? 0) / duration) * (trackWidth ?? 0);
  const halfIconWidth = 20 / 2;
  const leftAdjusted = Math.min(
    Math.max(halfIconWidth, left) + jitter,
    (trackWidth ?? Infinity) - halfIconWidth,
  );
  const { highlightedCommentId, activeCommentId } = useAppSelector(
    (state) => state.ticket,
  );

  const Icon = comment.isRequired ? Prohibit : Warning;

  return (
    <button
      tabIndex={0}
      onClick={() => comment.videoStart != null && onClick(comment.videoStart)}
      onKeyDown={(e) => {
        if (
          (e.key === "Enter" || e.key === " ") &&
          comment.videoStart != null
        ) {
          onClick(comment.videoStart);
        }
      }}
      className={cx(
        "duration-250 absolute flex size-5 -translate-x-1/2 transform items-center justify-center rounded-full transition-transform ease-in-out hover:z-[9999] hover:scale-125",
        {
          "z-[9999] scale-125":
            highlightedCommentId === comment._id ||
            activeCommentId === comment._id,
        },
      )}
      style={{
        left: `${(100 * leftAdjusted) / (trackWidth ?? 1)}%`,
        top: 6,
        backgroundColor: comment?.isRequired
          ? "rgb(var(--puntt-red-9))"
          : "rgb(var(--puntt-gold-10))",
        border: "0.3px solid white",
        transformOrigin: "50% 100%",
      }}
    >
      <Icon size={12} weight="fill" className="text-base-white" />
    </button>
  );
}
